module.exports = __webpack_public_path__ + "static/media/hooksScaffoldingPath.14bd041d.md";